<template>
  <v-container fluid>
    <!-- <div class="dx-flex" style="display: flex; justify-content:space-between">
      <a-radio-group v-model="type" button-style="solid" style="margin-bottom:20px;">
        <a-radio-button value="ALL">全部</a-radio-button>
        <a-radio-button value="0"><img :src="$constant.xianlu" class="map-icon" />线路</a-radio-button>
        <a-radio-button value="1"><img :src="$constant.youju" class="map-icon" />邮局</a-radio-button>
        <a-radio-button value="2"><img :src="$constant.chongdianzhuang" class="map-icon" />充电桩</a-radio-button>
        <a-radio-button value="3"><img :src="$constant.chetou" class="map-icon" />车头</a-radio-button>
        <a-radio-button value="4"><img :src="$constant.guaxiang" class="map-icon" />挂箱</a-radio-button>
        <a-radio-button value="5"><img :src="$constant.zhengche" class="map-icon" />整车</a-radio-button>
      </a-radio-group>
    </div> -->
    <a-button-group style="margin-left:-8px; margin-bottom:10px;">
      <a-button :type="own_type === 0 ? 'primary' : ''" @click="changeTab(0)">全部</a-button>
      <a-button :type="own_type === 1 ? 'primary' : ''" @click="changeTab(1)">自有车</a-button>
      <a-button :type="own_type === 3 ? 'primary' : ''" @click="changeTab(3)">包车</a-button>
      <a-button :type="own_type === 2 ? 'primary' : ''" @click="changeTab(2)">临调</a-button>
    </a-button-group>
    <a-row :gutter="16">
      <a-col :span="3" style="padding: 0;" >
        <a-input-search v-model="searchtext" placeholder="请输入关键字" style="width:100%;" @search="onSearch" />
        <div style="height:calc(100vh - 150px);overflow-y:auto; text-align:center;">
          <!-- <a-tabs v-if="own_type !== 1" v-model="itemid" type="card" tabPosition="left" :tabBarStyle="{ width: '100%' }"
            @change="(v) => changetab(v)">
            <a-tab-pane v-for="item in flist" :key="item.value" :tab="item.text"></a-tab-pane>
          </a-tabs> -->

          <div >
            <div v-for="group in searchtext == '' ? cityGroups : cityGroupslist" :key="group.city">
              <div class="city-group">
                <div class="city-title">
                  <v-chip x-small color="primary" class="ml-2">{{ group.chetou }}头 {{ group.guaxiang }}挂</v-chip>
                  <span class="city-title-name">{{ group.city }}</span>
                </div>
                <div class="city-items">
                  <div v-for="item in group.items" :key="item._id" class="plate-card" @click="handleVehicleClick(item)">
                    <span class="plate-text" :class="{ 'plate-text-active': item.value === itemid }">{{ item.text ||
                      item.name || item._id }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <a-tabs  v-if="own_type == 1" v-model="itemid" type="card" tabPosition="left" :tabBarStyle="{ width: '100%' }"
            @change="(v) => changetab(v)">
            <a-tab-pane v-for="group in cityGroups" :key="group.city">
              <template #tab>
                <div class="city-tab">
                  <span class="city-tab-name">{{ group.city }}</span>
                  <a-badge :count="group.count" :number-style="{ backgroundColor: '#1677ff' }" />
                </div>
              </template>

<a-empty v-if="!group.items || group.items.length === 0" description="该城市暂无车辆" />
<a-list v-else size="small" :dataSource="group.items" :pagination="{ pageSize: 20, size: 'small' }" rowKey="_id">
  <a-list-item slot="renderItem" slot-scope="item">
    <a-list-item-meta>
      <template #title>
                        <a href="javascript:;" @click="focusVehicle(item)">
                          {{ item.text || item.name || item._id }}
                        </a>
                      </template>
      <template #description>
                        <span :class="['shape-tag', `shape-${item.shape}`]">{{ shapeLabel(item.shape) }}</span>
                        <span style="margin-left:8px;color:#888;">{{ item.address || '' }}</span>
                      </template>
    </a-list-item-meta>
  </a-list-item>
</a-list>
</a-tab-pane>
</a-tabs> -->
        </div>
      </a-col>
      <a-col :span="21" >
        <a-spin :spinning="loading">
          <div style="position:relative;">
            <div style="height:calc(100vh - 100px);justify-content: center;position: relative" id="map"></div>
            <div v-if="vehicle" class="vehicle-info-panel">
              <div class="vehicle-info-header">
                <span class="vehicle-plate">{{ vehicle.vehicle_number }}</span>
                <a-icon type="close" class="vehicle-close" @click="vehicle = null" />
              </div>
              <div class="vehicle-info-body">
                <div class="info-row"><span class="info-label">挂箱号</span><span class="info-value">{{
                  vehicle.vehicle_gnumber
                    }}</span></div>
                <div class="info-row"><span class="info-label">执行邮路</span><span class="info-value red-text">{{
                  vehicle.postroute }}</span></div>
                <div class="info-row"><span class="info-label">状态</span><span class="info-value">{{ vehicle.vehiclestate
                    }}</span></div>
                <div class="info-row"><span class="info-label">剩余里程</span><span class="info-value red-text">{{
                  vehicle.left_km
                    ? vehicle.left_km + 'KM' : '' }}</span></div>
                <div class="info-row"><span class="info-label">车型</span><span class="info-value red-text">{{
                  vehicle.vehicle_type }}</span></div>
                <div class="info-row"><span class="info-label">车辆属性</span><span class="info-value red-text">{{
                  vehicle.own_type }}</span></div>
                <div class="info-row"><span class="info-label">速度</span><span class="info-value">{{ vehicle.speed
                    }}KM/H</span></div>
                <div class="info-row info-address">
                  <span class="info-label">位置</span>
                  <span class="info-value">
                    <p>{{ vehicle.addressTime }}</p>
                    <p>{{ vehicle.addressTitle }}</p>
                    <p>{{ vehicle.address }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-col>
    </a-row>
  </v-container>
</template>
<script>
import { message } from "ant-design-vue";
import _ from "underscore";
import { Scene, PolygonLayer, PointLayer, GaodeMap, LineLayer } from '@antv/l7';
import cityBounds from '@/assets/cityBounds.json';


export default {
  data() {
    return {
      loading: false,
      own_type: 0,
      searchtext: '',
      showresult: false,
      list: [],
      points: {},
      itemid: 'ALL',
      mapScene: null,
      pointLayer: null,
      lineLayer: null,
      circleLayer: null,
      labelLayer: null,
      selectedCircleLayer: null,
      data: {},
      vehicle: null,
      cityGroups: [],
      map: {
        center: [114.314521, 22.62032],
        zoom: 16,
      },
    }
  },


  
  components: {},
  computed: {

    cityGroupslist() {
      // 搜索框为空：原样返回
      const q = String(this.searchtext || '').trim().toLowerCase();
      if (!q) return this.cityGroups || [];

      const groups = this.cityGroups || [];
      const shapeLabelMap = {
        chetou: '车头', guaxiang: '挂箱', zhengche: '整车',
        youju: '邮局', chongdianzhuang: '充电桩', xianlu: '线路',
      };
      return groups
        .map((g) => {
          // 城市名命中：整个城市保留
          if (g.city && g.city.toLowerCase().includes(q)) {
            return g;
          }
          // 否则按车牌 / shape 中文标签 / shape 字段名 过滤车辆
          const items = (g.items || []).filter((v) => {
            const plate = (v.text || v.name || v._id || '').toLowerCase();
            if (plate.includes(q)) return true;
            const label = shapeLabelMap[v.shape] || '';
            if (label && label.includes(q)) return true;
            if (v.shape && v.shape.toLowerCase().includes(q)) return true;
            return false;
          });
          if (items.length === 0) return null;
          return { city: g.city, count: items.length, items };
        })
        .filter(Boolean)
        .sort((a, b) => b.count - a.count);
    },

    flist() {
      if (this.showresult) {
        let list = this.list.filter(n => {
          return n.text.includes(this.searchtext);
        });
        return list;
      }
      else return this.list;
    },
  },
  watch: {



    // type(ov, nv) {
    //   if (ov !== nv) {
    //     this.itemid = 'ALL';
    //     this.getdata();
    //   }
    // },
  },
  activated() {

  },
  mounted() {
    this.initMap();
  },
  methods: {


    async changeTab(v) {
       this.own_type = v;
       this.getdata();
    },
    onSearch(value) {
      console.log('onSearch', value);
      this.showresult = !!value;
      console.log('      this.showresult ', value);
    },
    changetab(v) {
      console.log('getdata', v);
      if (v === 'ALL') {
        this.vehicle = null;
      }
      else {
        let point = this.points?.features?.find(n => n.properties._id === v);
        if (point) {
          this.showData(point.properties);
        }
        else {
          let item = this.list.find(n => n.value === v);
          console.log(item);

          if (item) {
            this.showData({ _id: v, shape: item.type })
          }
        }
      }
      this.getdata();
    },
    initMap() {
      this.loading = true;
      const scene = new Scene({
        id: 'map',
        preserveDrawingBuffer: true,
        map: new GaodeMap({
          // center: [113.683173, 34.727964],
          center: this.map.center,
          style: 'light',
          // style: 'dark',
          pitchEnable: false,
          token: 'df486db18336b76e44d3d80a0cd23ce6',
          zoom: this.map.zoom,
        }),
      });
      this.mapScene = scene;
      scene.on('loaded', async () => {
        //邮局
        scene.addImage('xianlu', this.$constant.xianlu);
        scene.addImage('youju', this.$constant.youju);
        scene.addImage('chongdianzhuang', this.$constant.chongdianzhuang);
        scene.addImage('chetou', this.$constant.chetou);
        scene.addImage('guaxiang', this.$constant.guaxiang);
        scene.addImage('zhengche', this.$constant.zhengche);
        scene.addImage(
          'arrow',
          'https://gw.alipayobjects.com/zos/bmw-prod/ce83fc30-701f-415b-9750-4b146f4b3dd6.svg',
        );
        // const dataList = [
        //   `${process.env.BASE_API}/geojson/410000.json`,//河南省
        // ];
        // const result = await Promise.all(dataList.map(async (url) => await (await fetch(url)).json()));
        //省
        // const cityLayer = new PolygonLayer({
        //   autoFit: true,
        // })
        //   .source(result[0])
        //   .shape('fill')
        // .scale('COLOR', {
        //   type: 'cat',
        //   domain: ['Y', 'P', 'G', 'R'],
        // })
        // .color('COLOR', ['#f7f6c6', '#fceaea', '#e0e7d5', '#f3e4cf']);
        //地市边界
        // const city_Line = new PolygonLayer()
        //   .source(result[0])
        //   .shape('line')
        //   .size(0.5)
        //   .color('#787269');
        // 城市标注
        // let city = {
        //   "type": "FeatureCollection",
        //   "name": "市级行政区地级市行政中心",
        //   "features": result[0].features.map(n => {
        //     return {
        //       "type": "Feature",
        //       "properties": n.properties,
        //       "geometry": {
        //         "type": "Point",
        //         "coordinates": n.properties.center,
        //       }
        //     }
        //   }),
        // };
        // const cityName = new PointLayer({
        //   maxZoom: 8,
        //   minZoom: 5,
        // })
        //   .source(city)
        //   .shape('name', 'text')
        //   .size(14)
        //   .color('#000')
        //   .style({
        //     fontWeight: 800,
        //     textAnchor: 'top',
        //     textAllowOverlap: true,
        //     textOffset: [0, 12],
        //   });

        // 城市点位
        // const cityPoint = new PointLayer({
        //   maxZoom: 7,
        //   minZoom: 5,
        // })
        //   .source(city)
        //   .shape('city')
        //   .size(5);
        // scene.addLayer(cityLayer);
        // scene.addLayer(city_Line);
        // scene.addLayer(cityName);
        // scene.addLayer(cityPoint);
        this.getdata();
      });
    },
    getdata() {
      this.loading = true;
      let params = {
        own_type: this.own_type,
        itemid: this.itemid,
      };
      this.$api.doAPI("/map/list", params).then((res) => {
        console.log(res);
        let cheliang = res.data.list;
        let weizhixinxi = res.data.points.features;
        // 合并车辆和位置信息（每辆车的经纬度）
        let array = [];
        for (let index = 0; index < cheliang.length; index++) {
          let item = cheliang[index];
          for (let index = 0; index < weizhixinxi.length; index++) {
            const element = weizhixinxi[index];
            if (element.properties.name === item.text) {
              array.push({ ...item, ...element.properties });
            }
          }
        }
        console.log(array);
        // 根据经纬度，按城市矩形范围把车辆分组
        const cityGroups = this.groupVehiclesByCity(array);
        console.log('按城市分组的车辆:', cityGroups);
        // 把分组结果挂到 this 上，方便模板/调试使用
        this.cityGroups = cityGroups;

        if (res.code === 0) {
          if (this.pointLayer) {
            this.pointLayer.off("click");
            this.mapScene?.removeLayer(this.pointLayer);
          }
          if (this.lineLayer) {
            this.mapScene?.removeLayer(this.lineLayer);
          }
          if (this.circleLayer) {
            this.mapScene?.removeLayer(this.circleLayer);
          }
          if (this.labelLayer) {
            this.mapScene?.removeLayer(this.labelLayer);
          }
          if (this.selectedCircleLayer) {
            this.mapScene?.removeLayer(this.selectedCircleLayer);
          }
          let labels = [];
          this.list = [
            { value: 'ALL', text: '全部' },
            ...res.data.list,
          ];
          this.points = res.data.points;
          //图标图层
            if (res.data.points?.features?.length > 0) {
              this.pointLayer = new PointLayer({ zIndex: 10 })
                .source(res.data.points)
                .shape('shape')
                // 用预计算的 _size 字段驱动 size，便于"选中图标放大"即时生效
                .size('_size')
                .style({
                  opacity: 1,
                  // 选中时橙色描边
                  stroke: '#FF6B00',
                  strokeWidth: (item) => {
                    return item?.feature?.properties?._selected ? 2 : 0;
                  },
                });
            this.pointLayer.on("click", (e) => {
              const { feature } = e;
              if (feature?.properties) {
                console.log('点击的数据:', feature);
                // 地图点被点击时也同步选中态（与左侧列表联动）
                this.itemid = feature.properties._id || null;
                this.refreshSelectedMarkerSize();
                this.showData(feature.properties);
              }
            });
            this.mapScene.addLayer(this.pointLayer);
            // 首次加载时根据当前 itemid 预计算 _size / _selected / _color
            this.refreshSelectedMarkerSize();
            labels.push(...res.data.points.features.map(n => {
              return {
                m: n.properties.name,
                w: Number(n.properties.latitude),
                j: Number(n.properties.longitude),
                t: 10,
                s: "河南",
                // 选中态字段：车牌号、_id、_color（labelLayer 用 _color 驱动文字色）
                _id: n.properties._id,
                _name: n.properties.name,
                _color: '#084081',
              };
            }))
          }
          //线路
          if (res.data.lines?.features?.length > 0) {
            this.lineLayer = new LineLayer({ zIndex: 1 })
              .source(res.data.lines)
              .size(3)
              .shape("line")
              .texture('arrow')
              .color("rgb(22,119,255)")
              .animate({
                interval: 1, // 间隔
                duration: 1, // 持续时间，延时
                trailLength: 2, // 流线长度
              })
              .style({
                opacity: 0.6,
                borderWidth: 0.4,
                borderColor: '#fff',
                lineTexture: true, // 开启线的贴图功能
                iconStep: 10, // 设置贴图纹理的间距
              });
            this.mapScene.addLayer(this.lineLayer);
          }
          //邮局周围方圆
          if (res.data.circles?.features?.length > 0) {
            this.circleLayer = new PolygonLayer({ zIndex: 0 })
              .source(res.data.circles)
              .size(2)
              .shape("line")
              .color("red")
              .style({
                opacity: 0.2,
              });
            this.mapScene.addLayer(this.circleLayer);
          }
          // 选中专用圆环图层：zIndex 15，介于 pointLayer (10) 和 labelLayer (20) 之间
          // 选中车辆时在其位置绘制一个橙色圆环作为视觉指示
          this.selectedCircleLayer = new PointLayer({ zIndex: 15 })
            .source([], {
              parser: {
                type: 'json',
                x: 'j',
                y: 'w',
              },
            })
            .shape('circle')
            .size(60) // 圆环大小（直径，屏幕像素）
            .color('#FF6B00') // 橙色
            .style({
              opacity: 0.25, // 半透明填充
              stroke: '#FF6B00', // 描边色
              strokeWidth: 2, // 描边宽度
              strokeOpacity: 0.9, // 描边不透明
            });
          this.mapScene.addLayer(this.selectedCircleLayer);
          //标签
          if (labels.length > 0) {
            this.labelLayer = new PointLayer({ zIndex: 20 })
              .source(labels, {
                parser: {
                  type: 'json',
                  x: 'j',
                  y: 'w',
                },
              })
              .shape('m', 'text')
              .size(12)
              // 用 _color 字段驱动颜色：选中车辆的车牌变橙红，未选中保持深蓝
              .color('_color')
              .style({
                textAnchor: 'center', // 文本相对锚点的位置 center|left|right|top|bottom|top-left
                textOffset: [0, 30], // 文本相对锚点的偏移量 [水平, 垂直]
                spacing: 2, // 字符间距
                padding: [0, 0], // 文本包围盒 padding 改为 0，避免密集车辆 label 被碰撞检测剔除
                stroke: '#ffffff', // 描边颜色
                strokeWidth: 2, // 描边宽度
                strokeOpacity: 1.0,
                // rotation: 60, // 常量旋转
                rotation: {
                  // 字段映射旋转
                  field: 't',
                  value: [0, 0],
                },
              });
            this.mapScene.addLayer(this.labelLayer);
          }
          // 选中专用 labelLayer 数据同步：用 _color 字段控制车牌文字颜色，
          // 选中车辆的车牌号变橙色，未选中保持默认深蓝
          this.refreshSelectedMarkerSize();
          setTimeout(() => {
            if (res.data.center) {
              this.mapScene.setCenter(res.data.center);
            }
          }, 100);
        } else {
          message.error(res.msg);
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
    // 根据经纬度，把车辆分到对应的城市
    // 数据源：src/assets/cityBounds.json（全国 358 个地级市/地区精确矩形包围盒）
    // 最终结果：{ city, count, items: [...] }，items 内是命中的车辆原始信息
    groupVehiclesByCity(list) {
      // 把所有城市平铺成统一结构：[{ name, province, minLng, maxLng, minLat, maxLat }]
      const all = (cityBounds.cities || []).map((c) => ({
        name: c.name,
        province: c.province,
        minLng: c.minLng, maxLng: c.maxLng,
        minLat: c.minLat, maxLat: c.maxLat,
      }));

      // 用 Map 收集"城市 -> { count, items }"
      const groups = new Map();
      const ensure = (city) => {
        if (!groups.has(city)) {
          groups.set(city, { city, chetou: 0, guaxiang: 0, items: [] });
        }
        return groups.get(city);
      };

      for (const v of (list || [])) {
        const lat = Number(v.latitude);
        const lng = Number(v.longitude);
        if (isNaN(lat) || isNaN(lng)) continue;

        // 矩形包围盒判定：lng/minLng..maxLng 且 lat/minLat..maxLat 即匹配
        const matched = all.find((a) =>
          lng >= a.minLng && lng <= a.maxLng &&
          lat >= a.minLat && lat <= a.maxLat
        );
        if (matched) {
          const g = ensure(matched.name);
          g.items.push(v);
          if (v.shape === 'guaxiang') {
            g.guaxiang++;
          } else {
            // chetou / zhengche 计入车头数
            g.chetou++;
          }
        }
      }

      // 输出 [{ city, chetou, guaxiang, items }]，按 车头+车挂 倒序
      return Array.from(groups.values())
        .sort((a, b) => (b.chetou + b.guaxiang) - (a.chetou + a.guaxiang));
    },
    // 把 shape 字段翻译成中文标签
    shapeLabel(shape) {
      console.log(shape);
      
      const map = {
        chetou: '车头',
        guaxiang: '挂箱',
        zhengche: '整车',
        xianlu: '线路',
        youju: '邮局',
        chongdianzhuang: '充电桩',
      };
      return map[shape] || shape || '';
    },
    // 左侧城市列表里点击某辆车：把地图中心移动到该车，并弹出车辆信息浮窗
    focusVehicle(item) {
      if (!item) return;
      if (this.mapScene && Number.isFinite(item.latitude) && Number.isFinite(item.longitude)) {
        this.mapScene.setCenter([Number(item.longitude), Number(item.latitude)]);
      }
      if (item.shape === 'chetou' || item.shape === 'zhengche'||item.shape === 'guaxiang') {
        // 车头/整车才走 showData 接口，其它只挪地图视角
        this.showData({ _id: item._id, shape: item.shape });
      } else {
        // 其它类型直接展示可读信息
        this.vehicle = { ...item, vehicle_number: item.text || item.name };
      }
    },
    // 点击车牌卡片的统一入口
    // 1. 焦点跳到地图
    // 2. 同步 itemid（让"全部"tab里的侧栏能定位）
    // 3. 触发点 size 重算，使"选中的图标放大"立即生效
    handleVehicleClick(item) {
      if (!item) return;
      console.log('plate-card click:', item);
      this.focusVehicle(item);
      this.itemid = item._id;
      this.refreshSelectedMarkerSize();
    },
    // 重新计算每个 feature 的 _size（基础/放大）和 _selected（描边）字段
    // 然后 setData 触发 L7 重绘，使"选中的图标放大"立即生效
    // 同时把选中车辆的车牌号在 labelLayer 里渲染为橙红色
    // 并在 selectedCircleLayer 绘制一个橙色圆环
    refreshSelectedMarkerSize() {
      if (!this.pointLayer || !this.points?.features?.length) return;
      const features = this.points.features.map((f) => {
        const props = f.properties || {};
        const shape = props.shape;
        const base = (shape === 'chetou' || shape === 'guaxiang' || shape === 'zhengche') ? 28 : 16;
        const isSel = this.itemid && props._id === this.itemid;
        return {
          ...f,
          properties: {
            ...props,
            _size: isSel ? Math.round(base * 1.8) : base,
            _selected: isSel ? 1 : 0,
          },
        };
      });
      this.pointLayer.setData({ ...this.points, features });

      // 同步 labelLayer：选中车辆的车牌号变橙红，未选中保持默认深蓝
      if (this.labelLayer && this.points.features) {
        const labelFeatures = this.points.features.map((f) => {
          const props = f.properties || {};
          const isSel = this.itemid && props._id === this.itemid;
          return {
            m: props.name,
            w: Number(props.latitude),
            j: Number(props.longitude),
            t: 10,
            s: "河南",
            _id: props._id,
            _name: props.name,
            _color: isSel ? '#FF4500' : '#084081',
          };
        });
        this.labelLayer.setData(labelFeatures);
      }

      // 同步 selectedCircleLayer：选中车辆的位置绘制一个橙色圆环
      if (this.selectedCircleLayer) {
        const sel = features.find((f) => f.properties._selected === 1);
        const circleData = sel ? [{
          j: Number(sel.properties.longitude),
          w: Number(sel.properties.latitude),
        }] : [];
        this.selectedCircleLayer.setData(circleData);
      }
    },
    showData(params) {
      if (params.shape !== 'chetou' && params.shape !== 'zhengche' && params.shape !== 'guaxiang') {
        return;
      }
      this.loading = true;
      this.$api.doAPI("/map/show", params).then((res) => {
        this.loading = false;
        if (res.code === 0) {
          this.vehicle = res.data.data;
        }
        else {
          message.error(res.msg);
        }
      }).catch((err) => {
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="less" scoped>
img.map-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

// 城市分组 Tab 标题：城市名 + 车辆数徽章
.city-tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 2px 0;

  .city-tab-name {
    flex: 1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// 城市分组块（按城市展示车辆，每辆车一个车牌样式卡片）
.city-group {
  margin-bottom: 6px;

  .city-title {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    border-radius: 4px;
    margin-bottom: 6px;
    justify-content: space-between;

    .city-title-name {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
  }

  .city-items {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .plate-card {
    box-sizing: border-box;
    width: 100%;
    min-height: 40px;
    padding: 6px 16px;
    background: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // transition: all 0.15s;
    .plate-text {
      // font-family: 'Consolas', 'Menlo', 'Courier New', monospace;
      font-size: 14px;
      display: inline-block;
      width: 96px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #333;

      &:hover {
        color: #1890ff;
      }
      // 选中态：边框变蓝、加深背景
      &.plate-text-active {
        color: #1890ff;
      }
    }
  }
}

// 城市分组树（自有车模式）
.city-tree {
  padding: 4px 6px;
}

// 车辆类型小标签
.shape-tag {
  display: inline-block;
  padding: 0 6px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 3px;
  color: #fff;
  background: #999;
}

.map-info {
  position: absolute;
  right: 0;
  width: 30%;
  top: 0%;
  z-index: 9999;
}

.vehicle-info-panel {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1000;
  width: 300px;
  max-width: calc(100% - 32px);
  max-height: calc(100% - 32px);
  overflow-y: auto;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  font-size: 13px;

  .vehicle-info-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid #3385FF;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;

    .vehicle-plate {
      color: #3385FF;
      font-size: 16px;
      font-weight: 600;
    }

    .vehicle-close {
      cursor: pointer;
      color: #999;
      font-size: 14px;

      &:hover {
        color: #333;
      }
    }
  }

  .vehicle-info-body {
    padding: 8px 12px;

    .info-row {
      display: flex;
      padding: 3px 0;
      line-height: 1.5;

      .info-label {
        flex: 0 0 60px;
        color: #888;
      }

      .info-value {
        flex: 1;
        word-break: break-all;

        &.red-text {
          color: red;
        }
      }

      &.info-address .info-value p {
        margin: 0;
        padding: 0;
      }
    }
  }
}

p {
  margin: 0;
  padding: 0;
}
</style>
